import * as React from "react";

import { Loader } from "lib/components/Loader";
import { getStore, QueryResult } from "../../store";
import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table } from "react-bootstrap";
import * as styles from "./style.module.css";
import I18n from "lib/I18n";
import moment from "moment";
import { usePublisher } from "bundles/BigqueryQueryViewer/lib/pubsub";

export const Job = observer(() => {
  const store = getStore().list;
  const rootStore = getStore();
  const publisher = usePublisher();

  useEffect(() => {
    store.listQueryResults();
  }, []);

  const onSelect = (queryResult: QueryResult) => {
    if (rootStore.forms.find((_) => _.queryResult == queryResult)) {
      publisher.publish(queryResult, "focus");
      return;
    }
    // App/index.tsx側でdockviewに同期される
    rootStore.createFormStoreFromQueryResult(queryResult);
    queryResult.getQuery(rootStore.app.titleUuid, rootStore.app.env);
  };

  return (
    <div className={styles.root}>
      <Loader show={store.isLoading}>
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>{I18n.t("bigquery_query_viewer.label.job_status")}</th>
              <th>{I18n.t("bigquery_query_viewer.label.job_id")}</th>
              <th>{I18n.t("bigquery_query_viewer.label.enqueued_at")}</th>
              <th>{I18n.t("bigquery_query_viewer.label.job_query")}</th>
            </tr>
          </thead>
          <tbody>
            {store.queryResults.map((queryResult, i) => (
              <tr key={i}>
                <td className={styles.statusCell}>
                  {I18n.t(
                    `bigquery_query_viewer.label.status_${queryResult.queryStatus}`,
                  )}
                </td>
                <td className={styles.jobIdCell}>
                  <a href="#" onClick={() => onSelect(queryResult)}>
                    {queryResult.queryId}
                  </a>
                </td>
                <td className={styles.enquenedAtCell}>
                  {moment(queryResult.enqueuedAt).format("YYYY-MM-DD HH:mm:ss")}
                </td>
                <td className={styles.queryCell}>{queryResult.query}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Loader>
    </div>
  );
});
